import React from 'react';
import { Container, Divider } from '../design-system';
import { Mail, Phone, MapPin, Github, Linkedin, Twitter } from 'lucide-react';

export function Footer() {
  const footerLinks = {
    company: [
      { label: 'Sobre Nós', href: '#' },
      { label: 'Equipe', href: '#' },
      { label: 'Carreira', href: '#' },
      { label: 'Blog', href: '#' }
    ],
    services: [
      { label: 'Desenvolvimento Web', href: '#services' },
      { label: 'Apps Mobile', href: '#services' },
      { label: 'Backend & APIs', href: '#services' },
      { label: 'Consultoria', href: '#services' }
    ],
    resources: [
      { label: 'Documentação', href: '#' },
      { label: 'Portfólio', href: '#' },
      { label: 'Casos de Sucesso', href: '#' },
      { label: 'FAQ', href: '#faq' }
    ]
  };

  const socialLinks = [
    { icon: Github, href: '#', label: 'GitHub' },
    { icon: Linkedin, href: '#', label: 'LinkedIn' },
    { icon: Twitter, href: '#', label: 'Twitter' }
  ];

  return (
    <footer className="bg-slate-900 text-white pt-16 pb-8">
      <Container maxWidth="xl">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          <div className="lg:col-span-2">
            <div style={{ width: 180, height: 60, backgroundColor: '#ffffff' }} />
            <p className="mt-4 text-slate-400 max-w-md">
              Transformando ideias em soluções digitais inovadoras. 
              Especialistas em desenvolvimento de software de alta qualidade.
            </p>
            
            <div className="mt-6 space-y-3">
              <div className="flex items-center gap-3 text-slate-400">
                <Mail className="w-5 h-5" />
                <a href="mailto:contato@gruty.com" className="hover:text-white transition-colors">
                  contato@gruty.com
                </a>
              </div>
              <div className="flex items-center gap-3 text-slate-400">
                <Phone className="w-5 h-5" />
                <a href="tel:+5511999999999" className="hover:text-white transition-colors">
                  +55 (11) 99999-9999
                </a>
              </div>
              <div className="flex items-center gap-3 text-slate-400">
                <MapPin className="w-5 h-5" />
                <span>São Paulo, SP - Brasil</span>
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Empresa</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-slate-400 hover:text-white transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Serviços</h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-slate-400 hover:text-white transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Recursos</h4>
            <ul className="space-y-3">
              {footerLinks.resources.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-slate-400 hover:text-white transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <Divider className="bg-slate-800 my-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-400 text-sm">
            © 2024 Gruty Software. Todos os direitos reservados.
          </p>

          <div className="flex gap-4">
            {socialLinks.map((social) => {
              const Icon = social.icon;
              return (
                <a
                  key={social.label}
                  href={social.href}
                  aria-label={social.label}
                  className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-indigo-600 transition-colors"
                >
                  <Icon className="w-5 h-5" />
                </a>
              );
            })}
          </div>
        </div>
      </Container>
    </footer>
  );
}
